import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Main from '../pages/main/main.js';
import IdPwdConfirm from '../pages/login/idPwdConfirm.js';
import IdSearch from '../pages/login/idSearch.js';
import IdSearchDone from '../pages/login/idSearchDone.js';
import PwdSearch from '../pages/login/pwdSearch.js';
import PwdSearchDone from '../pages/login/pwdSearchDone.js';
import StoreContent from '../pages/store/storeContent.js';
import StoreSupport from '../pages/store/storeSupport.js';
import UserConfirm from '../pages/user/userConfirm.js';
import UserContent from '../pages/user/userContent.js';
import UserSignUp from '../pages/user/userSignUp.js';
import Agreement from '../pages/user/agreement.js';
import AgreementWrap from '../pages/user/agreementWrap.js';
import Privacy from '../pages/user/privacy.js';
import PrivacyWrap from '../pages/user/privacyWrap.js';
import AccountValidationPopup from '../pages/popup/AccountValidationPopup.js';
import Roulette from '../pages/event/roulette.js';
import AppDownload from '../pages/download/appDownload.js';

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/login-idsearch" element={<IdSearch />} />
      <Route path="/login-idsearch-done" element={<IdSearchDone />} />
      <Route path="/login-pwdsearch" element={<PwdSearch />} />
      <Route path="/login-pwdsearch-done" element={<PwdSearchDone />} />
      <Route path="/login-confirm" element={<IdPwdConfirm />} />
      <Route path="/user-signup" element={<UserSignUp />} />
      <Route path="/user-content" element={<UserContent />} />
      <Route path="/user-confirm" element={<UserConfirm />} />
      <Route path="/user-agreement" element={<Agreement />} />
      <Route path="/user-agreement-wrap" element={<AgreementWrap />} />
      <Route path="/user-privacy" element={<Privacy />} />
      <Route path="/user-privacy-wrap" element={<PrivacyWrap />} />
      <Route path="/store-content" element={<StoreContent />} />
      <Route path="/store-support" element={<StoreSupport />} />
      <Route path="/app-download" element={<AppDownload />} />
      <Route
        path="/popup/account-validation"
        element={<AccountValidationPopup />}
      />
      <Route path="/event/roulette" element={<Roulette />} />
      <Route path="/event/roulette/:eventNo" element={<Roulette />} />
    </Routes>
  );
}
